 <!--==========================
      Services Section
    ============================-->
    <section id="services" class="section-bg">
      <div class="container">

        <header class="section-header">
          <h1 style="text-align: center;">Services</h1>         
        </header>

        <div class="row">
          <div class="col-md-4 bounceInUp" data-wow-duration="1.4s">
            <div class="box">
              <div  style="width:300Px;height:200px;margin:auto;" > <img src="../assets/img/cloud.png" class="img-fluid" alt="" title="Cloud Based Solutions" > </div>
              <h4 class="title"> <a fragment="Cloud-Based-Solutions">Cloud Based Solutions</a> </h4>
              <p class="description">We have strong experience in IaaS, PaaS, and SaaS, all three main models of cloud computing services. </p>
            </div>
          </div>
          <div class="col-md-4 bounceInUp" data-wow-duration="1.4s">
            <div class="box">
              <div style="width:300Px;height:200px;margin:auto;" > <img src="../assets/img/c-software.png" class="img-fluid" alt="" title="Custom Software Development"> </div>
              <h4 class="title"> <a fragment="Custom-Software-Development">Custom Software Development</a> </h4>
              <p class="description">Our Experienced software engineers take charge of converting your business logic into scalable solutions using different technology platforms.</p>
            </div>
          </div>
          <div class="col-md-4 bounceInUp" data-wow-duration="1.4s">
            <div class="box">
              <div style="width:300Px;height:200px;margin:auto;" > <img src="../assets/img/mobile.png" class="img-fluid" alt="" title="Mobile Application Development"> </div>
              <h4 class="title"><a fragment="Mobile-Application-Development" >Mobile Application Development</a></h4>
              <p class="description">We have a high level of expertise on mobile app development skills to build and deploy app's on any mobile platform.</p>
            </div>
          </div>
          <div class="col-md-4 bounceInUp" data-wow-duration="1.4s">
            <div class="box">
              <div style="width:300Px;height:200px;margin:auto;" > <img src="../assets/img/web.png" class="img-fluid" alt="" title="Web Application Development"> </div>
              <h4 class="title"><a fragment="Web-Application-Development" >Web Application Development</a></h4>
              <p class="description">Our web development team uses modern javascript frameworks like angular & Microsoft tools for backend development.</p>
            </div>
          </div>
          <div class="col-md-4 bounceInUp" data-wow-duration="1.4s">
            <div class="box">
              <div style="width:200Px;height:200px;margin:auto;" > <img src="../assets/img/testing.png" class="img-fluid" alt="" title="Software Testing"> </div>
              <h4 class="title"><a fragment="Software-Testing" >Software Testing</a></h4>              
              <p class="description">Our QA automation team has experienced automation testing engineers with expertise in Web, Mobile, and API testing.</p>
            </div>
          </div>
          <div class="col-md-4 bounceInUp" data-wow-duration="1.4s">
            <div class="box" style="align-items: center">
              <div > <img src="../assets/img/database.png" class="img-fluid" alt="" title="Database Development"> </div>
              <h4 class="title"><a fragment="Database-Development" >Database Development</a></h4>
              <p class="description" style="text-align: left;">Our database developers have many years experience designing these complex custom database systems for businesses.</p>
            </div>
          </div>

        </div>

      </div>
    </section><!-- #services -->